import { createSelector } from '@reduxjs/toolkit';

export const groupViewSelector = (state: ReduxState) => state.groupViewReducer;
export const getGroupView = createSelector(groupViewSelector, (group) => group.groupView);
